import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

@Injectable()
export class UserService extends BaseAPIService {

    private ROUTES = {
        getUsers: '/user/id/search/v2/:type',
        saveUserLog: '/user/log/save',
        resetOnborading: '/user/reset/onboarding',
        getWelcomeQuestVersions: '/user/onboarding/v3/versions',
        getWelcomeQuestStatus: '/user/onboarding/v3/status',
        resetWelcomeQuest: '/user/reset/welcome-quest',
        endWelcomeQuest: '/user/onboarding/v3'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    getUsers(type: string, keyword: string): Promise<any> {
        return this.GET(this.ROUTES.getUsers, { type }, { params: { keyword } }).toPromise();
    }

    saveUserLog() {
        return this.POST(this.ROUTES.saveUserLog).toPromise();
    }

    resetOnboarding(opts: any): Promise<any> {
        return this.DELETE(this.ROUTES.resetOnborading, null, opts).toPromise();
    }

    getWelcomeQuestVersions(): Promise<any> {
        return this.GET(this.ROUTES.getWelcomeQuestVersions).toPromise();
    }

    getWelcomeQuestStatus(userId: number): Promise<any> {
        return this.GET(this.ROUTES.getWelcomeQuestStatus, null, { params: { userId: userId } }).toPromise();
    }

    resetWelcomeQuest(opts: any): Promise<any> {
        return this.DELETE(this.ROUTES.resetWelcomeQuest, null, opts).toPromise();
    }

    endWelcomeQuest(opts: any): Promise<any> {
        return this.DELETE(this.ROUTES.endWelcomeQuest, null, opts).toPromise();
    }
}
